import { GerenciadorProcessoItemButtonTypeEnum, GerenciadorProcessoListData } from 'src/app/shared/shared-components/gerenciador-processo/model/gerenciador-processo-list-data.model';
import { ModuloAnaliseEnum } from 'src/app/shared/shared-models/enums/modulo-analise.enum';
import { StatusSolicitacaoClassificacaoEnum } from "src/app/shared/shared-models/enums/status-solicitacao-classificacao.enum";
import { ROLES } from "src/app/shared/shared-utils/consts/const-roles";
import { GlobalValues } from 'src/app/shared/shared-values/global-values';

export const JogosEletronicosRPGValues = {

    moduloAnaliseId: ModuloAnaliseEnum.JOGO_ELETRONICO_RPG,

    header: {
        title: 'Jogos eletrônicos e RPG'
    },

    lists: [
        {
            title: 'Aguardando análise',
            statusId: StatusSolicitacaoClassificacaoEnum.AGUARDANDO_ANALISE,
            permissoes: {
                editar: ROLES.AREAS_TECNICAS_JOGOS_RPG_EDITAR,
                visualizar: ROLES.AREAS_TECNICAS_JOGOS_RPG_VISUALIZAR
            },
            itemButtonType: GerenciadorProcessoItemButtonTypeEnum.BUTTON,
        } as GerenciadorProcessoListData,

        {
            title: 'Aguardando autorização para publicação',
            statusId: StatusSolicitacaoClassificacaoEnum.AGUARDANDO_AUTORIZACAO,
            permissoes: {
                editar: ROLES.TRIAGEM_PENDENCIAS_EDITAR,
                visualizar: ROLES.TRIAGEM_PENDENCIAS_VISUALIZAR
            },
            itemButtonType: GerenciadorProcessoItemButtonTypeEnum.MENU,
        } as GerenciadorProcessoListData,

        {
            title: 'Aguardando reconsideração',
            statusId: StatusSolicitacaoClassificacaoEnum.EM_RECONSIDERACAO,
            permissoes: {
                editar: ROLES.REQUERIMENTO_RECONSIDERACAO_ANALISAR,
                visualizar: ROLES.REQUERIMENTO_RECONSIDERACAO_VISUALIZAR
            },
            itemButtonType: GerenciadorProcessoItemButtonTypeEnum.BUTTON,
        } as GerenciadorProcessoListData,

        {
            title: 'Aguardando recurso',
            statusId: StatusSolicitacaoClassificacaoEnum.AGUARDANDO_RECURSO,
            permissoes: {
                editar: ROLES.REQUERIMENTO_RECURSO_ANALISAR,
                visualizar: ROLES.REQUERIMENTO_RECURSO_VISUALIZAR
            },
            itemButtonType: GerenciadorProcessoItemButtonTypeEnum.BUTTON,
        } as GerenciadorProcessoListData,

        {
            title: 'Revisão de classificação',
            statusId: StatusSolicitacaoClassificacaoEnum.REVISAO_CLASSIFICACAO,
            permissoes: {
                editar: ROLES.REVISAO_CLASSIFICACAO_ANALISAR,
                visualizar: ROLES.REVISAO_CLASSIFICACAO_VISUALIZAR
            },
            itemButtonType: GerenciadorProcessoItemButtonTypeEnum.BUTTON,
        } as GerenciadorProcessoListData,
    ],


    btn: {
        action: {
            label: 'ir para análise por unidade',
            tooltip: 'Analisar processo',
            icon: 'grading'
        }
    },

    menu: {
        gerarPortaria: {
            title: GlobalValues.authorizePublicacao,
            icon: 'create'
        },
        analisarReconsideracao: {
            title: GlobalValues.analyseReconsideracao,
            icon: 'edit'
        }
    }
};
